/**
 * @file config.ts
 * @description Centralized configuration for the frontend application, including API endpoints.
 * Allows switching between different backend environments (development, staging, production)
 * by using environment variables.
 */

import log from "./logging";

const config = {
  firebaseConfig: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: process.env
      .REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
    appId: process.env.REACT_APP_FIREBASE_APP_ID as string,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string,
  },
  backendUrl: process.env.REACT_APP_BACKEND_URL as string,
  stripeCustomerPortalUrl: process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL as string,
};

log.debug("Application config:", config);

export default config;
